import { AppDispatch, Store } from 'store';
import { gtmProductImpressionEvent } from 'utils/gtm/gtmProductImpressionEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import getGtmProductsData from '../selector/getGtmProductsData';

const sendGtmProductImpressionOperation =
  (designs: string[], positions: number[]) => (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();
    const gtmProductsData = getGtmProductsData(store);
    const gtmData = designs.map((design) => gtmProductsData[design]);
    gtmSendEvent(gtmProductImpressionEvent(gtmData, positions));
  };

export default sendGtmProductImpressionOperation;
